<template>
  <div class="PageBox">
	  <div class="ScrollBox" style="background-color: #FFE501 ;">
		<van-nav-bar
		  fixed
		  :border="false"
		  :title="$t('direct[6]')"
		  left-arrow 
		  @click-left="$router.go(-1)"
		></van-nav-bar>
		<div class="Site">
		  <div class="content">
			<!-- <h1 style="color: #000;">{{$t('direct[0]')}}</h1>
			<p style="margin-bottom: 10px;color: #000;">{{$t('direct[1]')}}</p> -->
			<img :src="`./static/images/tuijian/img_bg@2x.png`" style="width:100%;margin-top: -65px;">
			<div class="content-member">
			  <h2 style="color: #000;text-align: center;padding: 10px;">{{$t('direct[2]')}}</h2>
			  <div style="color: #000;text-align: left;font-size: 0.9rem;padding:10px;" >
					<div v-html="$t('direct[3]')"></div>
					<div v-for="(item, index) in list" :key="index">
					<van-cell>
						<template #icon> 
							<div class="member-icon">
								{{InitData.currency}}{{moneyFormat(item.amount)}}
							</div>
						</template>
						<template #title>
							<div style="color: #000;height: 30px;margin-top:10px">{{$t('direct[4]')}}</div>
							<van-progress style="margin-top:30px" :pivot-text="getStr(item.num)" color="#37774C" stroke-width="12" :percentage="vip_num >= item.num ? 100 : (vip_num/item.num)*100" />
						</template>	
					</van-cell>
					<div v-if="vip_num >= item.num && item.is_received<1">
						<van-button size="small" type="default" class="btn" round style="background-color: #37774C;border: 1px solid #37774C;color: #fff;width: 100%;font-size: 12px;" @click="clickBtn(item.id)">{{$t('direct[7]')}}</van-button>
					</div>
					<div v-else-if="item.is_received>0">
						<van-button size="small" type="default" class="btn"  round style="background-color: #ccc;border: 1px solid #ccc;color: #fff;width: 100%;font-size: 12px;">{{$t('direct[8]')}}</van-button>	
					</div>
					<div v-else>
						<van-button size="small" type="default" class="btn" round style="background-color: #ccc;border: 1px solid #ccc;color: #fff;width: 100%;font-size: 12px;" @click="toPromote()">{{$t('direct[5]')}}</van-button>
					</div>		
				</div>
			  </div>
			</div>
		  </div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  name: "DirectMembers",
  components: {},
  data() {
    return {
		list:[],
		vip_num:0,
	};
  },
  computed: {},
  watch: {},
  created() {
	this.getData()
  },
  mounted() {},
  activated() {},
  destroyed() {},
  methods: {
	 toPromote(){
      this.$router.push("/promote");
    },
	  clickBtn(id) {
		  this.$Model.doDirect(id,data=>{
			  this.$Dialog.Toast(data.code_dec);
			  this.getData();
		  })
	  },
	  getStr(num) {
		  return  this.vip_num + "/" + num;
	  },
	  moneyFormat(num) {
	  	return new Intl.NumberFormat().format(Number(num).toFixed(2));
	  },
	  getData() {
		  this.$Model.getDirect({},data=>{
		  	this.list = data.activity;
		  	this.vip_num = data.direct;
		  })
	  }
  },
};
</script>
<style lang="scss" scoped>
// .Site {
//   background-image: url("../assets/images/directMembers/img_bg@2x.png"); /* 替换为你的图片路径 */
//   background-size: contain;
//   background-repeat: no-repeat;
// }
.content-member {
	width: 340px;
    background: #FFFFFF;
    border-radius: 15px 15px 15px 15px;
    margin: 0 auto;
}

 h2{
  background-image: url("/static/images/tuijian/img_characters@2x.png"); /* 替换为你的图片路径 */
  background-size: 95% 83px;
  background-repeat: no-repeat;
  background-position: center;
}

.member-icon {
  background-image: url("/static/images/tuijian/ico_redenvelope@2x.png"); /* 替换为你的图片路径 */
  background-size: cover; /* 图片铺满整个容器，可能会被裁剪 */
  background-repeat: no-repeat; /* 防止背景图重复 */
  background-position: center; /* 图片居中显示 */
  width: 100px;height: 110px;color: #37774C;text-align: center;padding-top:38px;
  font-weight: bold;
}

.PageBox {
overflow-y: auto;
}
.Site .van-cell {
    background-color: #fff;
    color: #0C1221;
    width: 100%;
    margin: 0;
}
.Site .van-cell__title{padding-left: 10px;}
::v-deep .van-nav-bar__content {
  background: linear-gradient(to right, $theme-shallow-color, $theme-color);
  color: #fff;
}

::v-deep .van-nav-bar__title {
  color: #fff;
}

::v-deep .van-nav-bar .van-icon {
  color: #fff !important;
}
::v-deep .van-nav-bar__text{
	color: #fff;
}
</style>
